import "./Select.scss";
import { Select as AntSelect } from "antd";

export const Select = ({
  title,
  options = [],
  placeholder,
  onChange,
  className,
  hideX,
  ...props
}) => {
  const { Option } = AntSelect;

  return (
    <div className={`select-input-container ${className || ""}`}>
      {title && <div className="select-title">{title}</div>}
      <AntSelect
        placeholder={placeholder}
        onChange={(value) => onChange(value)}
        style={{ width: "100%" }}
        {...props}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.name}
          </Option>
        ))}
      </AntSelect>
    </div>
  );
};

export default Select;
